<template>
  <div>
    <div v-if="noLeaguePackage" class="overlay-section">
      <div class="overlay-header overlay-header__team">
        <div class="premium">
          <v-icon v-if="userType === 'teams'" large>confirmation_number</v-icon>
          <v-icon v-else large>loop</v-icon>
        </div>
        <h2 style="text-align: center" v-if="userType === 'teams'">SAISONTICKET</h2>
        <h2 style="text-align: center" v-else>MATCH-ABOS</h2>
        <p>
          <b v-if="userType === 'teams'"
            >Mit dem Saisonticket kannst du während der gesamten Laufzeit unbegrenzt
            Spieler und Trainer matchen - so funktioniert effiziente Kaderplanung &
            digitales Talentscouting.</b
          >
          <b v-else
            >Wähle ein beliebiges Abo mit verschiedenen Laufzeiten, um unbegrenzt
            Spieler und Trainer matchen zu können.</b
          >
        </p>
      </div>
      <StripePayment />
    </div>
    <div v-else class="match">
      <!-- <button class="button-search" @click="$router.push({name:'team_match'})">Connect-Anfragen</button> -->
      <v-tabs
        v-model="tab"
        fixed-tabs
        background-color="white"
        class="mt-2"
        slider-color="light-green accent-4"
      >
        <v-tab href="#Spieler">Spieler</v-tab>
        <v-tab href="#Trainers">Trainer</v-tab>
        <v-tabs-items :touchless="true">
          <v-tab-item value="Spieler">
            <v-list>
              <v-list-group no-action>
                <template v-slot:activator>
                  <div class="history-wrapper list-name">
                    <h3 v-text="'Filter auswählen'"></h3>
                  </div>
                </template>
                <PlayerFilters
                  @reset-filters="resetFilters"
                  :player_switches.sync="player_switches"
                  :user_data.sync="user_data"
                />
              </v-list-group>
            </v-list>
            <div class="full-spinner" v-if="loading">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
            <div class="match-results" v-else>
              <ResultsList
                :count="allFilteredPlayers.length"
                :user-data="user_data"
                :no-league-package="noLeaguePackage"
                type="view_player"
                :results="filteredPlayers"
                :bluryResults="isTop3LeagueAndInactive"
                @switch-watchlist="
                  updateFilters('watchlist', $event, 'player_switches')
                "
                @switch-matched="updateFilters('matched', $event, 'player_switches')"
                @switch-de-matched="
                  updateFilters('dematched', $event, 'player_switches')
                "
                @switch-avatar="updateFilters('with_avatar', $event, 'player_switches')"
                @switch-active-account="
                  updateFilters('account_active', $event, 'player_switches')
                "
                @open-profile="openProfile"
                @name-searched="filterName($event, 'players')"
              />
              <div class="load-more-button__wrapper">
                <v-btn
                  v-if="allFilteredPlayers.length > 20"
                  @click="limits.players += 20"
                  class="menu-button main main-small"
                >
                  Mehr anzeigen
                </v-btn>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item value="Trainers">
            <v-list>
              <v-list-group no-action>
                <template v-slot:activator>
                  <div class="history-wrapper list-name">
                    <h3 v-text="'Filter auswählen'"></h3>
                  </div>
                </template>
                <TrainerFilters
                  @reset-filters="resetFilters"
                  :trainer_switches.sync="trainer_switches"
                  :user_data.sync="user_data"
                />
              </v-list-group>
            </v-list>
            <div class="full-spinner" v-if="loading">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
            <div v-else class="match-results">
              <ResultsList
                type="view_trainer"
                :results="filteredTrainers"
                :count="allFilteredTrainers.length"
                :user-data="user_data"
                :no-league-package="noLeaguePackage"
                :bluryResults="isTop3LeagueAndInactive"
                @switch-watchlist="
                  updateFilters('watchlist', $event, 'trainer_switches')
                "
                @switch-matched="updateFilters('matched', $event, 'trainer_switches')"
                @switch-de-matched="
                  updateFilters('dematched', $event, 'trainer_switches')
                "
                @switch-avatar="
                  updateFilters('with_avatar', $event, 'trainer_switches')
                "
                @switch-active-account="
                  updateFilters('account_active', $event, 'trainer_switches')
                "
                @open-profile="openProfile"
                @name-searched="filterName($event, 'trainers')"
              />
              <div class="load-more-button__wrapper">
                <v-btn
                  v-if="allFilteredTrainers.length > 20"
                  @click="limits.trainers += 20"
                  class="menu-button main main-small"
                >
                  Mehr anzeigen
                </v-btn>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>

      <MatchSheet
        v-if="tab === 'Spieler' && currentPlayer.id"
        :selectedProfile="currentPlayer"
        @close="view_player = false"
        :show="view_player"
      ></MatchSheet>

      <MatchSheetTrainer
        v-if="tab === 'Trainers' && currentPlayer.id"
        :selectedProfile="currentPlayer"
        @close="view_trainer = false"
        :show="view_trainer"
      ></MatchSheetTrainer>
    </div>

    <v-dialog v-model="top3LeaguesPopup" max-width="290">
      <v-card class="dialog">
        <v-card-title class="headline">Freischaltung Matching-Tool</v-card-title>

        <v-card-text>
          Kontaktiere dazu bitte unsere Geschäftsleitung, um einen persönlichen
          Gesprächstermin zu vereinbaren.
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <a class="v-btn theme--light" href="tel:+49-39-287-680-412">Per Telefon</a>
          <a class="v-btn theme--light" href="mailto:s.matzke@chance4talents.de"
            >Per E-Mail</a
          >
          <!-- <v-btn text @click="top3LeaguesPopup = false">Schließen</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src

import { mapState } from 'vuex';
import { db } from '@/db';
import MatchSheet from '@/components/match/PlayerSheet';
import MatchSheetTrainer from '@/components/match/TrainerSheet';
import PlayerFilters from '@/components/filters/PlayerFilters';
import TrainerFilters from '@/components/filters/TrainerFilters';
import filters from '../../mixins/filters';
import ResultsList from '../../components/lists/Results';

import { playerConverter, trainerConverter } from '../../helpers/firebase-converters';
import StripePayment from '../payment/StripePayment';

export default {
  name: 'match',

  components: {
    MatchSheet,
    MatchSheetTrainer,
    PlayerFilters,
    TrainerFilters,
    ResultsList,
    StripePayment,
  },

  mixins: [filters],

  data: () => ({
    dialog: false,
    top3LeaguesPopup: false,
    currentPlayer: {
      settings: {},
    },
    view_profile: false,
    view_trainer: false,
    view_player: false,
  }),

  computed: {
    ...mapState(['user_data']),

    loading() {
      return !(this.players !== null && this.trainers !== null);
    },
  },

  methods: {
    async openProfile(data, type) {
      // if withConverter, get full profile before setting currentPlayer
      this.$store.state.loading = true;

      let collection;
      switch (type) {
        case 'view_player':
          collection = 'users';
          break;
        case 'view_trainer':
          collection = 'trainers';
          break;
        case 'view_team':
          collection = 'teams';
          break;
        default:
          break;
      }

      const fullData = await db
        .collection(collection)
        .doc(data.id)
        .get()
        .then((snap) => snap.data());

      this.currentPlayer = fullData;
      this[type] = true;
      this.$store.state.loading = false;
    },
  },

  firestore: {
    players: db
      .collection('users')
      .withConverter(playerConverter)
      .where('name', '!=', '')
      .orderBy('name', 'asc'),
    trainers: db
      .collection('trainers')
      .withConverter(trainerConverter)
      .where('name', '!=', '')
      .orderBy('name', 'asc'),
  },

  created() {
    if (this.user_data.userType !== 'teams') {
      this.$router.push({ name: 'dummyHome' });
    }

    this.tab = this.user_data.selectedTab;

    if (this.isTop3LeagueAndInactive) {
      this.top3LeaguesPopup = true;
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/components/_match.scss';
</style>
